// extracted by mini-css-extract-plugin
export default {"indexText":"ConversationChange_indexText__2OyTq","alignTestimonial":"ConversationChange_alignTestimonial__CJn9z"};